import { render, staticRenderFns } from "./VerificationCDDForm.vue?vue&type=template&id=059e43c6&"
import script from "./VerificationCDDForm.vue?vue&type=script&lang=js&"
export * from "./VerificationCDDForm.vue?vue&type=script&lang=js&"
import style0 from "./VerificationCDDForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports